var map = {
	"./template.betgalaxy": 2052,
	"./template.betgalaxy.tsx": 2052,
	"./template.betprofessor": 1143,
	"./template.betprofessor.tsx": 1143,
	"./template.betroyale": 1144,
	"./template.betroyale.tsx": 1144,
	"./template.default": 659,
	"./template.default.tsx": 659,
	"./template.fiestabet": 1145,
	"./template.fiestabet.tsx": 1145,
	"./template.puntcity": 1146,
	"./template.puntcity.tsx": 1146,
	"./template.puntgenie": 1147,
	"./template.puntgenie.tsx": 1147,
	"./template.questbet": 1148,
	"./template.questbet.tsx": 1148,
	"./template.ts": 971,
	"./template.volcanobet": 1149,
	"./template.volcanobet.tsx": 1149,
	"./template.wellbet": 1150,
	"./template.wellbet.tsx": 1150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2424;